import {RemoteCollectionStore, StoreBuilder} from "@softline/core";
import {Emballage} from "../types/warenuebernahme";

export const WwsEmballageStore = new StoreBuilder(RemoteCollectionStore.create<Emballage>())
  .value;
